import { render } from "./vTextLocalApi.vue?vue&type=template&id=176ac0a5&scoped=true"
import script from "./vTextLocalApi.vue?vue&type=script&lang=js"
export * from "./vTextLocalApi.vue?vue&type=script&lang=js"

import "./vTextLocalApi.vue?vue&type=style&index=0&id=176ac0a5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176ac0a5"]])

export default __exports__